import React, { useEffect, useState } from "react";
import { Tag, Input, Typography, Row, Col, Button, Space, Flex } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SpaceNewCard from "./SpaceNewCard";
import { useTranslation } from "react-i18next";
import { getSortedSpaces } from "../../../utils/currentUserDetail";

interface SapceListProps {
  spaces: any;
  userInfo: any
}

const { Title } = Typography;
const SpaceList: React.FC<SapceListProps> = ({ spaces, userInfo }) => {
  const { t } = useTranslation();
 const [searchText, setSearchText] = useState<any>()
 const [filteredSpaces, setFilteredSpaces] = useState(spaces)
 const favoriteSpaces = userInfo.favoriteSpaces || [];
 let favSpaces = [] as any;

 useEffect(() => {
  spaces.forEach((space:any) => {
    if(favoriteSpaces.includes(space.spaceId)) {
      favSpaces.unshift(space)
    } else {
      favSpaces.push(space)
    }
  })
  favSpaces = getSortedSpaces(favSpaces);
  setFilteredSpaces([...favSpaces])
 },[spaces])

 useEffect(() => {
   if(searchText){
     let filteredSpace = spaces.filter((s:any) => s.name && s.name.toLowerCase().includes(searchText.toLowerCase()))
     filteredSpace = getSortedSpaces(filteredSpace);
     setFilteredSpaces(filteredSpace)
   } else {
    let sortedSpaces = getSortedSpaces(spaces);
    setFilteredSpaces(sortedSpaces)
   }

 },[searchText])

  const searchHandler = (e:any) => {
    setSearchText(e.target.value)
  }
  
  return (
    <>
      <Row gutter={8} style={{ marginBottom: "16px" }}>
        <Col span={12} style={{padding: "8px 0"}}>
          <Space align="center">
            <Title level={3} style={{ margin: 0 }} className="page-sub-title">
              {t("Your Spaces")}
            </Title>
            {spaces && Array.isArray(spaces) ? (
              <Tag color="magenta" bordered={false}>{`${spaces.length} spaces`}</Tag>
            ) : null}
          </Space>
        </Col>
        <Col span={12} style={{ textAlign: "right", padding: "8px 0" }}>
          <Space style={{gap: "16px"}}>
            <Input
              placeholder={t("Search a space")}
              allowClear
              onChange={searchHandler}
              suffix={<SearchOutlined style={{ marginRight: "8px" }} />}
            />
            <Button type="link" href="/app/space/all-spaces" style={{padding: "4px 0"}}>{t("View All")}</Button>
          </Space>
        </Col>
      </Row>
      <Flex justify="flex-start" gap={20} style={{ flexWrap: "wrap", justifyContent: "space-around" }}>
                {filteredSpaces.map((space: any) => {
                    return (
                        <SpaceNewCard key={space.spaceId} userInfo={userInfo} {...space} amISpaceManager={true} isFavorite={space.isFavorite || false} />

                    );
                })}
            </Flex>
    </>
  );
};

export default SpaceList;
